import { render, staticRenderFns } from "./VacancyAiQuestionsForm.vue?vue&type=template&id=79839847&scoped=true&"
import script from "./VacancyAiQuestionsForm.vue?vue&type=script&lang=js&"
export * from "./VacancyAiQuestionsForm.vue?vue&type=script&lang=js&"
import style0 from "./VacancyAiQuestionsForm.vue?vue&type=style&index=0&id=79839847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79839847",
  null
  
)

/* custom blocks */
import block0 from "./VacancyAiQuestionsForm.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyAiQuestionsForm.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VRow})
